module.exports = __webpack_public_path__ + "static/media/ic_busy.e3d3ba4c.svg";